import logo from "../assets/korrus-logo-white.png";

/** Korrus wordmark (white letters + taupe "o" ring). Never recolour the ring. */
export function KorrusMark() {
  return <img src={logo} alt="Korrus" />;
}
